function EventsSection() {
  return (
    <section id="events" className="ac-section ac-width ac-event">
      <div>
        <h2>Občas taky<br />ven z Discordu.</h2>
        <p>Občas se potkáme i naživo, naposledy na Párkobraní na podzim 2022.</p>
        <p>Nemáme týdenní rozvrh. Plán je na Discordu.</p>
        <a className="ac-text-link" href="https://discord.allcom.zone" target="_blank" rel="noopener noreferrer">Co se chystá, řešíme tam</a>
      </div>
      <article className="ac-event-record">
        <h3>Párkobraní</h3>
        <p className="ac-event-date">2022 <span>Minulá akce</span></p>
        <p>Sešli jsme se venku. Gril, hudba, soutěže. Evobug to dal dohromady.</p>
      </article>
    </section>
  )
}

export default EventsSection
